/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateOfferInput = {|
  clientMutationId?: ?string,
  description?: ?string,
  endDate?: ?any,
  finePrint?: ?string,
  id: string,
  isCheckIn: boolean,
  isFlash?: ?boolean,
  isLatest?: ?boolean,
  isPromoted?: ?boolean,
  isRedeemable?: ?boolean,
  isTop: boolean,
  redemptionCode?: ?string,
  startDate?: ?any,
  storeId?: ?string,
  title?: ?string,
|};
export type endOfferMutationVariables = {|
  input: UpdateOfferInput
|};
export type endOfferMutationResponse = {|
  +updateOffer: ?{|
    +offer: ?{|
      +id: string,
      +endDate: any,
      +store: {|
        +id: string
      |},
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type endOfferMutation = {|
  variables: endOfferMutationVariables,
  response: endOfferMutationResponse,
|};
*/


/*
mutation endOfferMutation(
  $input: UpdateOfferInput!
) {
  updateOffer(input: $input) {
    offer {
      id
      endDate
      store {
        id
      }
    }
    errors {
      key
      messages
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateOfferInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOfferPayload",
    "kind": "LinkedField",
    "name": "updateOffer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Offer",
        "kind": "LinkedField",
        "name": "offer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messages",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endOfferMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "endOfferMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "endOfferMutation",
    "operationKind": "mutation",
    "text": "mutation endOfferMutation(\n  $input: UpdateOfferInput!\n) {\n  updateOffer(input: $input) {\n    offer {\n      id\n      endDate\n      store {\n        id\n      }\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f217ca4f629d01d59affd130b876ec1b';

module.exports = node;
